// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"196":"61373344","480":"aaac8be9"}[chunkId] + ".css";
};